<template>
<!-- ======= SectionTwo Begins here =======  :pagination="{clickable: true}"-->
  <section class="services sectiontwo" data-aos="fade-up" :class="{pantopsection: pantheme === 'pantopsection'}">
    <div class="container card sectioncontrol" data-aos="fade-up">
        <div class="row align-items-start">
           <div class="col-sm-8 listdata">
            <div v-for="(years, index) in allyears" :key="years" :id="index%2 > 0 ? 'oddnewsbg' : 'evennewsbg'">
                <div class="rowhover" :id="years.abouthistid" @click="$emit('getId', $event.target.value=years.abouthistid)">
                    <div v-html="years.abouthistdesc" class="divtt"></div>
                </div>
            </div>

            </div>
            <div class="col-sm-4 yearcss">
                <div class="yearcss1">{{yearimages.aboutyear}}</div>
                <div v-if="showImage === false">
                    <img :src="`${getlastimage}`" class="imageresize">
                </div>
                <div v-else>
                    <img :src="yearimages.abouthistimage" class="imageresize" >
                </div>
            </div>
        </div>
    </div>

  </section><!-- End Services Section abouthistimage-->
</template>

<script>

export default {
    
    //------------Homepage Stock Prices---------------
    props: ['allyears', 'getselectedyear', 'yearimages', 'getlastimage', 'showImage', 'publicPath', 'pantheme'],
    data(){
        return {

        }
    },
methods: {
getId($event) {
    // id: $event.target.value
    this.$emit('getLinkId', $event.target.value)
}
},
mounted() {

}
}
</script>

<style scoped>
.sectiontwo {
    margin-top: -300px;
    margin-bottom: 30px;

}
.divdata {
    font-size: 18px;
    padding-left: 20px;
    padding-right: 20px;
   
    
}
.divtt{
    padding-top: 10px;
    padding-bottom:10px;
    height: auto;
    margin-top: 10px;
}
.listdata {
    overflow-y: scroll;
    height: 400px;
    color: #003;
    border: solid thin grey;
    border: 0px;
}
tr:nth-child(even) {background-color: #f2f2f2;}
.sectioncontrol {
    background-color: #EEEEEE;
}
.divdataref {
    text-decoration: none;
    color: #003;
}
.imageresize {
    width: 30%;
    margin-top: -60px;
    margin: 20px;
    border-radius: 5px;
}
.yearcss {
    background-image: url("../assets/slide-5.jpg");
    color: white;
    font-size: 24px;     
}
.yearcss1 {
  text-align: center;
  font-size: 36px;
  background: -webkit-linear-gradient(#003, white);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
}
.rowhover:hover {
    background-color: #003;
    color: white;
    margin: 0 auto;
    text-align: justify;
    padding-top: 5px;
    padding-bottom: 5px;
}
.rowhover {
    text-align: justify;
    cursor: pointer;
}
#oddnewsbg {
    background-color: rgb(177, 173, 173);
  }

/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
    .yearcss {
        width: 100%;
        margin-top: 60px;
    }
    .imageresize {
        width: 90%;
        margin-top: 0px;
        border-radius: 5px;
    }
    .sectioncontrol {
        width: 90%;
    }
    .sectiontwo {
        margin-top: -50px;
    }
    .listdata {
        width: 100%;
    }
 }

 @media only screen and (max-width: 360px) {
    
 }
 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
    .yearcss {
        width: 100%;
    }
    .imageresize {
        width: 90%;
        margin-top: -40px;
        border-radius: 5px;
    }
    .sectioncontrol {
        width: 90%;
    }
    .sectiontwo {
        margin-top: -80px;
    }
    .listdata {
        width: 100%;
    }
    .yearcss {
        margin-top: 80px;
        border-radius: 5px;
    } 
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
    .sectiontwo{
        margin-top: -0px;
    }
    .yearcss {
        margin-top: 80px;
    }
    .imageresize {
        margin-top: 30px;
    }
    .listdata {
     margin-top: -120px;
    }
 }



 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
    .sectiontwo{
        margin-top: -80px;
    } 
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
    .sectiontwo{
        margin-top: -40px;
        width: 100%;
    }
    .listdata {
        width: 52%;
        overflow-y: scroll;
        margin-top: 10px;
        padding: 20px;
    }
    .yearcss {
        width: 40%;
        margin-top: 20px;
        border-radius: 5px;
        margin-left: 90px;
    }
 }

 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1400px) {
    .sectiontwo{
        margin-top: -40px;
        width: 100%;
    }
    .listdata {
        width: 52%;
        overflow-y: scroll;
        margin-top: 10px;
        padding: 20px;
        margin-left: 10px;
        border: 0px;
    }
    .yearcss {
        width: 40%;
        margin-top: 20px;
        border-radius: 5px;
        margin-left: 90px;
    }
 }
</style>